import React from "react";
import { useAssignTag } from "@planzone/view-models";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function TagList(_: Props) {
  const { isRequestPending } = useAssignTag();

  return (
    <div className={styles.tagList}>
      <div className={styles.list}>
        <Skeleton className={styles.tag} />
        <Skeleton className={styles.tag} />
        <Skeleton className={styles.tag} />
      </div>
    </div>
  );
}

export { TagList };
